import React from 'react'
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group' // ES6

import SidePanel from './sidePanel'

import Button from '../../button/button';

import './sidePanel.styl'
export class SidePanelTransition extends React.Component {
    static TRANSITION_TIME = 500;
    static propTypes = {
        id: PropTypes.string.isRequired
    }

    transitionTime = SidePanelTransition.TRANSITION_TIME

    state = {}

    constructor(props) {
        super(props)
        this.close = this.close.bind(this)
    }

    componentDidMount() {
        SidePanel.PANELS[this.props.id] = this;
    }

    close(e) {
        e && e.preventDefault && e.preventDefault();
        this.setState({data: false})
        return Promise.resolve(e);
    }

    render() {
        const {data=false, className=false} = this.state
        const close = this.close;

        console.log('SidePanelTransition render, state=', this.state);
        console.log('SidePanelTransition render, props=', this.props);

        data && !data.type && console.log('SidePanelTransition render, should have data.type', data);
        data && !data.attrs && console.log('SidePanelTransition render, should have data.attrs', data);

        return <ReactCSSTransitionGroup
            transitionName={"sidePanel-background"}
            transitionEnterTimeout={this.transitionTime}
            transitionLeaveTimeout={this.transitionTime}
            transitionAppear={true}
            transitionAppearTimeout={this.transitionTime}>
            {data && <div className={'sidePanel' + (className ? ' ' + className : '')}>
                <div className="sidePanel-content">
                    {React.createElement(data.type, {...data.attrs, close})}
                </div>
                <Button className="sidePanel-close" icon="closeV2" label="app.close" onClick={close}/>
            </div>}
        </ReactCSSTransitionGroup>
    }
}

export default SidePanelTransition
